var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"error"}},[_c('ErrorComponent',{attrs:{"error_code":_vm.error_code,"error_message":_vm.error_message}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }